import axios from 'axios';

export function notebookData(url, callback) {
  return axios.get(url).then((response) => {
    callback({ status: 'success', data: response.data });
  });
}
